export default __webpack_public_path__ + "static/media/login-option-google.a1c09d67.svg";